import { httpRequest } from "@services/http"

export class CommandCreateObjectiveJourneySteps {
    async run(engagementId: number, objectiveId: number, steps: any) {
        const url = `${
          import.meta.env.VITE_API_PLATFORM_SERVICE_URL
        }api/v1/engagements/${engagementId}/objectives/${objectiveId}/journey-steps/`

        const body = {
            "id": steps.id,
            "name": steps.name,
            "sequence": steps.sequence,
            "landing_page_url": steps.landing_page_url
        }

        try {
            const response = await httpRequest<any>(url, {method: "POST", body})
            return response;
        } catch (error) {
            console.error("Error fetching data: ", error)
            throw error;
        }
    }
}